<template>
  <div class="page-cont">
    <h1 class="page-title">被禁设备列表</h1>
    
    <div class="device-container">
      <div v-if="deviceList.length === 0" class="no-data">
        暂无被禁设备
      </div>
      
      <div class="device-card" v-for="item in deviceList" :key="item.id">
        <div class="device-icon">
          <i class="el-icon-monitor"></i>
        </div>
        <div class="device-info">
          <h3 class="device-name" :title="item.device_name">{{ item.device_name }}</h3>
          <div class="info-item">
            <span class="label">ID:</span>
            <span class="value">{{ item.id }}</span>
          </div>
          <div class="info-item">
            <span class="label">Hash:</span>
            <el-tooltip :content="item.device_hash_id" placement="top">
              <span class="value hash-id">{{ item.device_hash_id }}</span>
            </el-tooltip>
          </div>
          <div class="info-item">
            <span class="label">创建时间:</span>
            <span class="value">{{ formatDate(item.create_time) }}</span>
          </div>
          <div class="info-item">
            <span class="label">过期时间:</span>
            <span class="value">{{ formatDate(item.expire_time) }}</span>
          </div>
        </div>
        <div class="device-actions">
          <el-button
            size="small"
            type="primary"
            @click="handleEnable(item)">恢复</el-button>
          <el-button
            size="small"
            type="danger"
            @click="handleDelete(item)">删除</el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'DisabledDeviceList',
  data() {
    return {
      deviceList: []
    };
  },
  mounted() {
    this.fetchDevices();
  },
  methods: {
    formatDate(dateStr) {
        if (!dateStr) return '';
        const date = new Date(dateStr);
        return date.toLocaleString();
    },
    async fetchDevices() {
      const token = localStorage.getItem('token');
      if (!token) {
        this.$message.error('未检测到登录凭证，请重新登录');
        this.$router.push('/login');
        return;
      }

      const loadingInstance = this.$loading({
        lock: true,
        text: '加载中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });

      try {
        const res = await axios.get(`${this.$store.state.ServerAddress}/api/admin/get-disabled-list`, {
          headers: {
            Authorization: `Bearer ${token}`
          }
        });

        if (res.data.success) {
          this.deviceList = res.data.data;
          this.$message.success(res.data.msg || '查询成功');
        } else {
            if (res.status === 401 || res.data.status === 401) {
                this.$message.error('登录已过期，请重新登录');
                localStorage.removeItem('UserEmail');
                localStorage.removeItem('token');
                this.$router.push('/login');
            } else {
                this.$message.error(res.data.msg || '查询失败');
            }
        }
      } catch (error) {
        console.error('获取设备列表失败:', error);
        if (error.response && error.response.status === 401) {
             this.$message.error('登录已过期，请重新登录');
             localStorage.removeItem('UserEmail');
             localStorage.removeItem('token');
             this.$router.push('/login');
        } else {
             this.$message.error('网络连接失败');
        }
      } finally {
        loadingInstance.close();
      }
    },
    handleEnable(item) {
      this.$confirm('此操作将恢复该设备访问权限, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const token = localStorage.getItem('token');
        try {
          const res = await axios.post(`${this.$store.state.ServerAddress}/api/admin/enable-device`, {
            deviceHashId: item.device_hash_id
          }, {
            headers: {
              Authorization: `Bearer ${token}`
            }
          });

          if (res.data.success) {
            this.$message.success('恢复成功');
            this.fetchDevices();
          } else {
            this.$message.error(res.data.msg || '恢复失败');
          }
        } catch (error) {
          console.error('恢复失败:', error);
          this.$message.error('操作失败');
        }
      }).catch(() => {
        this.$message.info('已取消操作');          
      });
    },
    handleDelete(item) {
      this.$confirm('此操作将永久删除该设备, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const token = localStorage.getItem('token');
        try {
          const res = await axios.post(`${this.$store.state.ServerAddress}/api/admin/delete-device`, {
            deviceHashId: item.device_hash_id
          }, {
            headers: {
              Authorization: `Bearer ${token}`
            }
          });

          if (res.data.success) {
            this.$message.success('删除成功');
            this.fetchDevices();
          } else {
            this.$message.error(res.data.msg || '删除失败');
          }
        } catch (error) {
          console.error('删除失败:', error);
          this.$message.error('操作失败');
        }
      }).catch(() => {
        this.$message.info('已取消删除');          
      });
    }
  }
};
</script>

<style scoped>
.page-cont {
  padding: 20px;
  background-color: white;
  min-height: calc(100vh - 20px);
  width: 90vw;
  box-sizing: border-box;
}

.page-title {
  margin-bottom: 20px;
  font-size: 24px;
  color: #303133;
  display: block;
}

.device-container {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  justify-content: flex-start;
  width: 100%;
}

.no-data {
  width: 100%;
  text-align: center;
  color: #909399;
  padding: 40px;
}

.device-card {
  width: calc((100% - 140px) / 8); /* 8 cards per row with 20px gap */
  min-width: 140px;
  border: 1px solid #ebeef5;
  border-radius: 8px;
  padding: 10px;
  background: white;
  box-shadow: 0 2px 12px 0 rgba(0,0,0,0.1);
  transition: all 0.3s;
  display: flex;
  flex-direction: column;
  align-items: center;
  box-sizing: border-box;
}

@media screen and (max-width: 1600px) {
  .device-card {
    width: calc((100% - 100px) / 6); /* 6 cards per row */
  }
}

@media screen and (max-width: 1200px) {
  .device-card {
    width: calc((100% - 60px) / 4); /* 4 cards per row */
  }
}

@media screen and (max-width: 800px) {
  .device-card {
    width: calc((100% - 20px) / 2); /* 2 cards per row */
  }
}

.device-card:hover {
  transform: translateY(-3px);
  box-shadow: 0 4px 12px 0 rgba(0,0,0,0.2);
}

.device-icon {
  margin-bottom: 8px;
}

.device-icon i {
  font-size: 30px;
  color: #F56C6C; /* Use red for disabled devices */
}

.device-info {
  width: 100%;
  margin-bottom: 10px;
}

.device-name {
  margin: 0 0 8px 0;
  font-size: 12px;
  color: #303133;
  text-align: center;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.info-item {
  display: flex;
  justify-content: space-between;
  margin-bottom: 4px;
  font-size: 10px;
}

.label {
  color: #909399;
  width: 40px;
  text-align: left;
}

.value {
  color: #606266;
  flex: 1;
  text-align: right;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.hash-id {
  font-family: monospace;
}

.device-actions {
  display: flex;
  gap: 8px;
  margin-top: auto;
  flex-wrap: wrap;
  justify-content: center;
}

.device-actions .el-button {
  padding: 5px 10px;
  font-size: 10px;
}
</style>
